import { Checkbox as BaseCheckbox } from '@base-ui/react/checkbox'
import { Check, Minus } from 'lucide-react'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface CheckboxIndicatorProps extends PartProps<BaseCheckbox.Indicator.Props> {
  className?: string
}

const GLYPH = 'text-on-info size-3 group-data-[disabled]/checkbox:text-foreground-disabled'

/**
 * The mark: a check, or a dash while indeterminate. Kept mounted so it can fade and grow in from
 * 60% rather than appear. Pass children to replace both glyphs.
 */
function CheckboxIndicator({ className, children, ...props }: CheckboxIndicatorProps) {
  return (
    <BaseCheckbox.Indicator
      keepMounted
      className={twMerge(
        'flex items-center justify-center',
        'transition-[opacity,scale] duration-150 ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:transition-none',
        'data-[unchecked]:scale-[0.6] data-[unchecked]:opacity-0',
        className,
      )}
      {...props}
    >
      {children ?? (
        <>
          <Check
            absoluteStrokeWidth
            strokeWidth={1.5}
            className={twMerge(GLYPH, 'group-data-[indeterminate]/checkbox:hidden')}
          />
          <Minus
            absoluteStrokeWidth
            strokeWidth={1.5}
            className={twMerge(GLYPH, 'hidden group-data-[indeterminate]/checkbox:block')}
          />
        </>
      )}
    </BaseCheckbox.Indicator>
  )
}

export { CheckboxIndicator }
